import React, { Component } from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import { Navbar, Nav, NavItem,  MenuItem, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';


const HeaderLogo = styled.img`
    width:120px;
`;

const RJRNavBar = styled(Navbar)`

    .container {
        padding: 0 30px;
        margin: 0px;
    }


    .navbar-nav {
        padding-top:20px;
    }
    
    .navbar-header {
        height:80px;
    }
    
    .dropdown:hover .dropdown-menu {
        display: block;
    }
    
    .navbar-nav li.dropdown:hover > a {
        color: #555;
        background-color: #e7e7e7;
    }    

    @media (min-width: 768px) {
        .container {
            width: auto;
        }
    }

    @media (max-width: 1080px) {
        .navbar-header {
            float: none;
        }
        .navbar-toggle {
            display: block;
            margin-top:28px;
            margin-left:10px;
            float:left;
        }
        .navbar-collapse {
            border-top: 1px solid transparent;
            box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1);
        }
        .navbar-collapse.collapse {
            display: none!important;
        }
    
        .navbar-collapse.collapse.in {
            display: block!important;
        }
        .navbar-nav {
            float: none!important;
            margin: 7.5px -15px;
        }
        .navbar-nav>li {
            float: none;
        }
        .navbar-nav>li>a {
            padding-top: 10px;
            padding-bottom: 10px;
        }
    }    

`;


class Header extends Component {

    handleOpen = (e) => {
        console.log(this);
        this.setState({ isOpen: true })
      }
    
      handleClose = (e) => {
         this.setState({ isOpen: false })
    }

    render() {
        return (
        <RJRNavBar onToggle={this.handleToggle}>
            <Navbar.Header>
                <Navbar.Brand>
                    <a href="/"><HeaderLogo alt="RJ Reynolds" src={process.env.PUBLIC_URL + '/static/media/rjr_logo.jpg'} /></a>
                    {/* <a className="navbar-brand" href="#">RJR Docs</a> */}
                </Navbar.Brand>
                <Navbar.Toggle  />   
            </Navbar.Header>
            { process.env.REACT_APP_ISSECURE === 'true' &&
              <Navbar.Collapse>
              <Nav>
                  <NavDropdown title="RJRT" id="nav-dropdown">
                    <LinkContainer to="/rjr/4B"><MenuItem>RJRT 4B</MenuItem></LinkContainer> 
                    <LinkContainer to="/rjr/privilege"><MenuItem>RJRT Privilege Index</MenuItem></LinkContainer>                             
                  </NavDropdown>
                  <NavDropdown title="Brown & Williamson" id="nav-dropdown">
                    <LinkContainer to="/bw/4B"><MenuItem>B&W 4B</MenuItem></LinkContainer> 
                    <LinkContainer to="/bw/privilege"><MenuItem>B&W Privilege Index</MenuItem></LinkContainer>
                  </NavDropdown>                    
                  <NavDropdown title="American Tobacco Company" id="nav-dropdown">
                    <LinkContainer to="/atco/4B"><MenuItem>ATCO 4B</MenuItem></LinkContainer> 
                    <LinkContainer to="/atco/privilege"><MenuItem>ATCO Privilege Index</MenuItem></LinkContainer>             
                  </NavDropdown>                    
                  <NavDropdown title="Lorillard" id="nav-dropdown">
                  <LinkContainer to="/lorillard/4B"><MenuItem>Lorillard 4B</MenuItem></LinkContainer> 
                      <LinkContainer to="/lorillard/privilege"><MenuItem>Lorillard Privilege Index</MenuItem></LinkContainer>
                  </NavDropdown>                    
                </Nav>
                </Navbar.Collapse>
            }   
            { (process.env.REACT_APP_ISSECURE === 'false' && this.props.location.pathname.indexOf('SitePages') === -1) &&
            <Navbar.Collapse>
                <Nav>
                    <NavItem href="/">Home</NavItem>
                    <NavItem href="/allCollections/allResults">All Collections</NavItem>
                    <NavDropdown title="RJRT" id="nav-dropdown">
                        <LinkContainer to="/rjr/public"><MenuItem>RJRT Public</MenuItem></LinkContainer>                        
                    </NavDropdown>
                    <NavDropdown title="Brown & Williamson" id="nav-dropdown">
                        <LinkContainer to="/bw/public"><MenuItem>B&W Public</MenuItem></LinkContainer>
                    </NavDropdown>                    
                    <NavDropdown title="American Tobacco Company" id="nav-dropdown">
                        <LinkContainer to="/atco/public"><MenuItem>ATCO Public</MenuItem></LinkContainer>            
                    </NavDropdown>                    
                    <NavDropdown title="Lorillard" id="nav-dropdown">
                        <LinkContainer to="/lorillard/public"><MenuItem>Lorillard Public</MenuItem></LinkContainer>
                    </NavDropdown>     
                </Nav>
            </Navbar.Collapse>
            }
            { (process.env.REACT_APP_ISSECURE === 'false' && this.props.location.pathname.indexOf('SitePages') > -1) &&
            <Navbar.Collapse>
                <Nav>             
                    <NavItem href="/allCollections/allResults">Search</NavItem>               
                </Nav>
            </Navbar.Collapse>
            }            
        </RJRNavBar>
        );
    }
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/shared/header.js